export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4007b7592d7828cc22c7def49717ccb81452f08910&name=revalidateCommunity!'